import React from 'react';
import ReactDOM from 'react-dom';
import smoothscroll from 'smoothscroll-polyfill';
import svg4everybody from 'svg4everybody';

import Qau from './app/Qau';
import './styles/index.scss';

smoothscroll.polyfill();
svg4everybody();

window.ondragenter = e => e.preventDefault();
window.ondragover = e => e.preventDefault();
window.ondragend = e => e.preventDefault();
window.ondrop = e => e.preventDefault();

ReactDOM.render(
  <React.StrictMode>
    <Qau />
  </React.StrictMode>,
  document.getElementById('qau-main-container'),
);
